/* eslint-disable react/prop-types */
import React from "react"; // React Stuff
// Common
import SpecialRequirements from "../../common/SpecialRequirementsTooltip.js";
//TimeRendering
import Moment from "react-moment";
//Packages
import axios from "axios";
import { Col, Row, Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

const ClassSubscribers = (props) => {
  // Pause the Subscription
  const pauseSubscription = async (stripe_subscription_id) => {
    const pauseRequest = await axios.put(
      `/api/admin/manage_subscription/pause_subscription`,
      { stripe_subscription_id },
      {
        withCredentials: true,
      }
    );
    if (pauseRequest.status === 200) {
      props.setSubmitClicked(false);
      setTimeout(() => props.fetchNewData(), 1000); // Wait a moment for Stripe API to respond on the web hook.
      return props.setSuccessMessage("Subscription successfully paused.");
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  //Unpause the Subscription
  const unpauseSubscription = async (stripe_subscription_id) => {
    const unpauseRequest = await axios.put(
      `/api/admin/manage_subscription/unpause_subscription`,
      { stripe_subscription_id },
      {
        withCredentials: true,
      }
    );
    if (unpauseRequest.status === 200) {
      props.setSubmitClicked(false);
      setTimeout(() => props.fetchNewData(), 1000); // Wait a moment for Stripe API to respond on the web hook.
      return props.setSuccessMessage("Subscription successfully unpaused.");
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  //Cancel the Subscription
  const cancelSubscription = async (stripe_subscription_id) => {
    const cancelRequest = await axios.delete(
      `/api/admin/manage_subscription/delete_subscription`,
      { data: { stripe_subscription_id } },
      {
        withCredentials: true,
      }
    );
    if (cancelRequest.status === 200) {
      props.setSubmitClicked(false);
      setTimeout(() => props.fetchNewData(), 1000); // Wait a moment for Stripe API to respond on the web hook.
      return props.setSuccessMessage("Cancellation initiated.");
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <Row className='mt-4 mb-4 text-center'>
      <Col className='border shadow p-3'>
        <h3 className='mt-4'>Subscriptions/Learners</h3>
        {props.data.Subscriptions.length > 0 ? (
          <Table striped bordered hover responsive size='sm' className='text-center'>
            <thead>
              <tr>
                <th>Name</th>
                <th className='d-none d-md-table-cell'>Stripe ID</th>
                <th>Status</th>
                <th className='d-none d-md-table-cell'>Details</th>
                <th>Pause?</th>
                <th>Cancel?</th>
              </tr>
            </thead>
            <tbody>
              {props.data.Subscriptions.map((Subscription) => (
                <tr key={Subscription._id}>
                  <td className='align-self-center align-middle'>
                    <small>
                      <Link to={`/admin/customer-list/${Subscription.SystemUserID}`}>
                        {Subscription.Participant_Name}{" "}
                      </Link>
                      {Subscription.Special_Requirements && (
                        <SpecialRequirements
                          specialRequirements={Subscription.Special_Requirements}
                        />
                      )}
                    </small>

                    <br />
                    <span className='smallprint'>
                      (
                      <Moment format='Y [year], M [months]' durationFromNow ago>
                        {Subscription.Participant_DoB}
                      </Moment>{" "}
                      old)
                    </span>
                  </td>
                  <td className='align-self-center align-middle d-none d-md-table-cell'>
                    {" "}
                    <a
                      target='_blank'
                      rel='noopener noreferrer'
                      href={`https://dashboard.stripe.com/subscriptions/${Subscription.stripe_subscription_id}`}
                    >
                      <small>{Subscription.stripe_subscription_id}</small>
                    </a>
                  </td>
                  <td className='align-self-center align-middle'>
                    <small>{Subscription.StripeStatus}</small>
                  </td>
                  <td className='align-self-center align-middle d-none d-md-table-cell'>
                    <Button
                      variant='info'
                      size='sm'
                      as={Link}
                      to={`/admin/customer-list/${Subscription.SystemUserID}`}
                      type='link'
                    >
                      Info
                    </Button>
                  </td>
                  <td className='align-self-center align-middle'>
                    <span>
                      {Subscription.StripeStatus !== "paused" ? (
                        <Button
                          className='btn btn-sm btn-secondary'
                          type='submit'
                          disabled={
                            Subscription.StripeStatus === "Last Payment / Cancelled" ||
                            Subscription.StripeStatus === "Payment Past Due" ||
                            props.submitClicked
                          }
                          onClick={(e) => pauseSubscription(Subscription.stripe_subscription_id, e)}
                        >
                          Pause
                        </Button>
                      ) : (
                        <Button
                          variant='secondary'
                          size='sm'
                          type='submit'
                          disabled={
                            Subscription.StripeStatus === "Last Payment / Cancelled" ||
                            Subscription.StripeStatus === "Payment Past Due" ||
                            props.submitClicked
                          }
                          onClick={(e) =>
                            unpauseSubscription(Subscription.stripe_subscription_id, e)
                          }
                        >
                          Unpause
                        </Button>
                      )}
                    </span>
                  </td>
                  <td className='align-self-center align-middle'>
                    <Button
                      variant='danger'
                      size='sm'
                      type='submit'
                      disabled={
                        Subscription.StripeStatus === "Last Payment / Cancelled" ||
                        Subscription.StripeStatus === "Payment Past Due" ||
                        props.submitClicked
                      }
                      onClick={(e) => cancelSubscription(Subscription.stripe_subscription_id, e)}
                    >
                      Cancel
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p>No Subscribers yet...</p>
        )}
      </Col>
    </Row>
  );
};

export default ClassSubscribers;
